/**
 * External dependencies.
 */
import React from "react";
import Image from "next/image";
import { Trans } from "@lingui/macro";

/**
 * Internal dependencies.
 */
import Intro from "components/intro/intro";
import { MediaProp } from "types";
import { ArticleTagProps, ArticleTagsProps } from "types/article";
import { articleDate, getStrapiMedia } from "utils";

interface ArticleIntroProps {
  title: String;
  tags: ArticleTagsProps;
  readTime: String;
  imgData: MediaProp;
  createdAt: Date;
  author: String;
}

const ArticleIntro: React.FC<ArticleIntroProps> = ({
  title,
  tags,
  readTime,
  imgData,
  createdAt,
  author,
}) => (
  <Intro Smaller={false} noMargin={true} className="intro--article">
    <Intro.Content>
      <div className="intro__head">
        {createdAt && (
          <div className="intro__head-date">{articleDate(createdAt)}</div>
        )}

        {author && (
          <div className="intro__head-author">
            <Trans>Written by</Trans> {author}
          </div>
        )}
      </div>

      {title && <h1 className="h3">{title}</h1>}

      <div className="article__meta article__meta--bright">
        {tags?.data && tags.data.length !== 0 && (
          <div className="article__meta-tags">
            {tags.data?.map((tag: ArticleTagProps, index: number) => (
              <span key={index}>{tag.attributes.Name}</span>
            ))}
          </div>
        )}

        {readTime && (
          <div className="article__meta-readtime">
            {readTime} <Trans>read</Trans>
          </div>
        )}
      </div>
    </Intro.Content>

    {imgData.data && (
      <Intro.Image>
        <Image alt="" src={getStrapiMedia(imgData)} width={664} height={442} />
      </Intro.Image>
    )}
  </Intro>
);

export default ArticleIntro;
